import React from 'react';

import GitlabLoginButton from '../../components/GitlabLoginButton/GitlabLoginButton';
import PageDefault from '../PageDefault/PageDefault';

import './Login.scss';

function Login() {
	return (
		<PageDefault status={status}>
			<div className="login">
				<div className="centered">
					<span className="title">Utilitários B2C</span>
					<div className="subtitle">Para prosseguir, faça login com sua conta.</div>

					<GitlabLoginButton />
				</div>
			</div>
		</PageDefault>
	);
}

export default Login;
